import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-play-circle-fill text-3xl text-primary-400"></i>
              </div>
              <span className="text-xl font-bold font-heading tracking-tight whitespace-nowrap">
                mogu视频
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              蘑菇街旗下专注时尚购物的短视频平台，边看边买，发现最新时尚趋势。
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors" aria-label="小红书">
                <i className="ri-red-packet-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/fashion-tips" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">穿搭教程</Link></li>
              <li><Link to="/category/beauty-review" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">美妆测评</Link></li>
              <li><Link to="/category/trending-items" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">潮流单品</Link></li>
              <li><Link to="/category/hairstyle-inspo" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">发型灵感</Link></li>
              <li><Link to="/category/bag-unboxing" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">包包开箱</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">品牌介绍</Link></li>
              <li><a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">创作者入驻</a></li>
              <li><a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">广告合作</a></li>
              <li><a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a></li>
              <li><a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">
              下载mogu视频
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed mb-3">
              扫码下载mogu视频App，随时随地发现时尚好物
            </p>
            <div className="flex gap-3">
              <a href="#" className="flex items-center gap-2 px-4 py-2.5 bg-background-800 hover:bg-background-700 rounded-lg text-sm text-background-100 transition-colors whitespace-nowrap">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-apple-line text-lg"></i>
                </div>
                App Store
              </a>
              <a href="#" className="flex items-center gap-2 px-4 py-2.5 bg-background-800 hover:bg-background-700 rounded-lg text-sm text-background-100 transition-colors whitespace-nowrap">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-android-line text-lg"></i>
                </div>
                安卓版
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 mogu视频 - 蘑菇街视频购物官方平台 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            <a href="#" className="hover:text-foreground-300 transition-colors" rel="nofollow">浙ICP备xxxxxxxx号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}